import React from "react";
import { UseFormRegisterReturn } from "react-hook-form";

const SelectField = React.forwardRef<
	HTMLSelectElement,
	{
		className?: string;
		errorMessage?: string;
		label: string;
		disabled?: boolean;
		value?: string;
		defaultValue?: string;
		options: {
			label: string;
			value: string;
		}[];
		grayBorder?: boolean;
	} & UseFormRegisterReturn
>(({ className, errorMessage, label, disabled, value, options, defaultValue, grayBorder, ...otherProps }, ref) => {
	return (
		<div className={`w-full space-y-2 ${className}`}>
			{label && <label className=" text-sm font-bold">{label}</label>}{" "}
			{errorMessage && <p className="text-xs font-medium text-red-500">{errorMessage}</p>}
			<select
				{...otherProps}
				ref={ref}
				disabled={disabled}
				className={`hover:front-bold flex w-full items-center rounded-md border bg-gray-50 px-2 focus:border-transparent focus:outline-none focus:ring-2 ${className} ${
					errorMessage ? "border-red-500 focus:ring-red-500" : "border-gray-400 focus:ring-primary"
				} ${grayBorder ? "border-2 !border-gray-300 bg-white" : ""}`}
				defaultValue={defaultValue}
				value={value}
			>
				{options.map((option, index) => (
					<option
						key={option.value + index}
						value={option.value}
						className="bg-gray-50 !font-geist-mono hover:bg-red-700"
					>
						{option.label}
					</option>
				))}
			</select>
		</div>
	);
});

SelectField.displayName = "SelectField";
export default SelectField;
